<template>
  <el-dialog
    title="特殊价格导入记录"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <ImportRecordList :category="2"></ImportRecordList>
  </el-dialog>
</template>
<script>
import ImportRecordList from '@/views/customer_export_record/list'
export default {
  components: {
    ImportRecordList,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
}
</script>